import Decimal from 'decimal.js-light'

import { InputsAnswer } from '~/bootcamp/Activities/types/activities.types'

export function randomIntFromInterval(min: number, max: number, excludeArr?: number[]): number {
  const excludedValueSet = new Set(excludeArr || [])
  const values = Array.from(new Array(max - min + 1).keys())
    .map((i) => i + min)
    .filter((v) => !excludedValueSet.has(v))

  const randomIndex = Math.floor(Math.random() * values.length)
  return values[randomIndex]
}

export function randomItemFromList(items: string[] | number[]): string | number {
  const index = Math.floor(Math.random() * items.length)
  const randomItem = items[index]
  return randomItem
}

export function randomIntFromChoices(choices: number[], excludeArr?: number[]): number {
  const index = Math.floor(Math.random() * choices.length)
  const randomNumber = choices[index]

  if (excludeArr && excludeArr.includes(randomNumber)) {
    return randomIntFromChoices(choices, excludeArr)
  }

  return randomNumber
}

export function generateDecimal(num: number, divisor: number): number {
  const digit = new Decimal(num)
  if (num % divisor !== 0) {
    return digit.dividedBy(divisor).toNumber()
  }
  return generateDecimal(num + 1, divisor)
}

export function isAllowedValue(value: string): boolean {
  if (!value) return true
  return /^([0-9\+\*\-\/\.\,\s])+$/g.test(value) // eslint-disable-line no-useless-escape
}

/* The decimal step of a long multiplication opens only once the sum has been written out, so the
   number is never offered decimal places while it is still being typed. A product of an m-digit
   and an n-digit factor has either m + n or m + n - 1 digits, so the leftmost box — and only the
   leftmost — may legitimately stay empty. */
export function isDecimalSumComplete(values: Record<string, string>): boolean {
  return Object.values(values)
    .slice(1)
    .every((digit) => digit !== '')
}

export const generateInitialAnswers = (iterableArray: number[], inputKey = 'answer'): InputsAnswer => {
  const initialAnswers: InputsAnswer = {}

  iterableArray.forEach((id) => {
    initialAnswers[`${inputKey}_${id}`] = ''
  })

  return initialAnswers
}

export const getFactors = (value: number, excludeArr?: number[]): number[] => {
  const result = Array.from({ length: value }, (_, i) => i + 1).filter((i) => value % i === 0)

  if (excludeArr && excludeArr.length > 0) {
    return result.filter((item) => excludeArr.includes(item) === false)
  }
  return result
}

/**
 * generates a random number from range, this is a updated version of randomIntFromInterval function
 * @param min minimum number to generate
 * @param max maximum number to generate
 * @param excludeNumbers this numbers will be excluded
 * @returns a randomly generated number of range
 */
export function generateRandomInt(min: number, max: number, excludeNumbers?: number[]): number {
  const excludes = new Set<number>(excludeNumbers || [])
  const values = Array.from(new Array(max - min + 1).keys())
    .map((i) => i + min)
    .filter((v) => !excludes.has(v))
  const randomIndex = Math.floor(Math.random() * values.length)
  return values[randomIndex]
}

export function shuffleArray<T>(array: T[], pick?: number): T[] {
  if (pick === 0) return []

  const arrayCopy = array.slice()
  let currentIndex = array.length
  let randomIndex
  // eslint-disable-next-line
  while (currentIndex !== 0) {
    randomIndex = Math.floor(Math.random() * currentIndex)
    currentIndex--
    ;[arrayCopy[currentIndex], arrayCopy[randomIndex]] = [arrayCopy[randomIndex], arrayCopy[currentIndex]]
  }
  return !pick ? arrayCopy : arrayCopy.slice(0, pick)
}

export function randomInRange(min = 0, max = 1): number {
  return Math.floor(Math.random() * (max - min)) + min
}

export function sortNumbers(numberArr: number[]): number[] {
  // eslint-disable-next-line fp/no-mutating-methods
  return [...numberArr].sort((a, b) => a - b)
}

export function multiplyNumbers(numberArr: number[]): number {
  return numberArr.reduce((prevNumber, currentNumber) => prevNumber * currentNumber)
}

export function hocOnEnterPress(
  answerState: boolean | null,
  handleCheckAnswer: () => void,
  handleGoToNextQuestion: () => void,
): void {
  if (answerState === null || answerState === false) handleCheckAnswer()
  else handleGoToNextQuestion()
}
